import React from 'react';
import logo from '../assets/logo-180.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src={logo} alt="AutoMestre" className="logo-img" />
          </div>
          <div className="copyright">
            © 2025 AutoMestre. Todos os direitos reservados.
          </div>
        </div>
      </div>

      <style>{`
        .footer {
          border-top: 1px solid var(--color-border);
          padding: 2rem 0;
          margin-top: auto;
          background: var(--color-bg);
        }
        .footer-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .footer-brand {
          display: flex;
          align-items: center;
        }
        .logo-img {
          height: 28px;
          width: auto;
          opacity: 0.9;
        }
        .copyright {
          color: var(--color-text-muted);
          font-size: 0.875rem;
        }
        
        @media (max-width: 640px) {
          .footer-content {
            flex-direction: column;
            gap: 1rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
